/*
  ============================================================================
  bb-coll-rail.js — il filtro marca della pagina collection

  DA DOVE VENGONO LE MARCHE
  Non da un elenco scritto a mano e non dai tag dei prodotti: da BBGarage,
  cioe' dalle auto che vendiamo davvero. Per ogni marca si prendono le sue auto
  e l'unione dei pezzi che ci vanno; incrociata con i prodotti presenti in
  questa collection, da' il conteggio. Quindi in "Intakes" compaiono solo le
  marche per cui un'aspirazione esiste davvero, con quante ne sono.

  COME CONVIVE CON L'ALTRO FILTRO
  Ogni filtro nasconde con la SUA classe: questo con .bb-make-hidden,
  l'interruttore "solo per la mia auto" con .bb-fit-hidden. Nessuno dei due
  rimette visibile quello che l'altro ha nascosto, quindi si sommano da soli e
  non c'e' niente da tenere in sincrono.

  I PRODOTTI SENZA COMPATIBILITA' NON SI NASCONDONO MAI
  Filtri, viti, abbigliamento: non appartengono a nessuna marca, e sparire da
  un filtro marca sarebbe una vendita persa senza motivo. Restano sempre.
  ============================================================================
*/
(function () {
  'use strict';

  /* ---------------------------------------- la descrizione ripiegata */
  (function descrizione() {
    var d = document.querySelector('.collection-hero__description');
    if (!d) return;
    d.classList.add('bb-desc--folded');
    if (d.scrollHeight - d.clientHeight < 24) { d.classList.remove('bb-desc--folded'); return; }
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'bb-desc__more'; b.textContent = 'Read more';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var aperto = !d.classList.toggle('bb-desc--folded');
      b.textContent = aperto ? 'Read less' : 'Read more';
      b.setAttribute('aria-expanded', String(aperto));
    });
    d.parentNode.insertBefore(b, d.nextSibling);
  })();

  var rail = document.querySelector('[data-bb-rail]');
  if (!rail) return;

  var lista   = rail.querySelector('[data-bb-rail-makelist]');
  var tutte   = rail.querySelector('[data-bb-rail-allmakes]');
  var nocar   = rail.querySelector('[data-bb-rail-nocar]');
  var apri    = document.querySelector('[data-bb-rail-open]');
  var chiudi  = rail.querySelector('[data-bb-rail-close]');
  var velo    = document.querySelector('[data-bb-rail-veil]');
  var conta   = document.querySelector('[data-bb-rail-count]');

  var MOSTRA = 8;          // marche visibili prima di "Show all makes"
  var scelta = null;
  var schede = [];         // {li, handle}

  function leggiSchede() {
    schede = [];
    Array.prototype.forEach.call(document.querySelectorAll('#product-grid > li'), function (li) {
      var h = li.querySelector('[data-bb-fit-card]');
      schede.push({ li: li, handle: h ? h.getAttribute('data-bb-fit-card') : null });
    });
  }

  /* marca -> insieme dei nostri handle che vanno su almeno una sua auto */
  function perMarca() {
    var g = window.BBGarage, d = g.data, out = Object.create(null);
    var marcaDi = Object.create(null);
    d.platforms.forEach(function (p) { marcaDi[p.id] = p.make; });
    Object.keys(d.products).forEach(function (h) {
      d.products[h].forEach(function (id) {
        var mk = marcaDi[id];
        if (!mk) return;
        (out[mk] = out[mk] || Object.create(null))[h] = 1;
      });
    });
    return out;
  }

  function applica() {
    var senzaDati = 0;
    schede.forEach(function (s) {
      var nascondi = false;
      if (scelta) {
        // Scelta una marca si vede SOLO quella marca. Prima restavano in lista
        // anche i pezzi senza compatibilita' (filtri, viti, targhetta): il
        // riquadro diceva "Ford 2" e sotto ne comparivano quattro, di cui due
        // che con una Ford non c'entrano niente. (7 set 2026)
        if (!s.handle) nascondi = false;                 // non e' una scheda prodotto
        else nascondi = !window.__bbPerMarca[scelta] || !window.__bbPerMarca[scelta][s.handle];
      }
      s.li.classList.toggle('bb-make-hidden', nascondi);
    });
    if (conta) {
      conta.hidden = !scelta;
      conta.textContent = scelta ? '1' : '';
    }
    if (tutte) tutte.hidden = lista.children.length <= MOSTRA;
    scriviConta();
    void senzaDati;
  }

  /*
    Il numero accanto a Sort (1 ott 2026): con una marca scelta restava "49
    products" mentre se ne vedevano 5. Con la marca si scrive "5 of 49
    products" (le schede visibili su quelle che Dawn conta col suo filtro);
    tolta la marca torna il testo di Dawn. Se Dawn lo riscrive (cambio di Sort
    o di filtro) il suo testo nuovo diventa quello da rimettere.
  */
  var contaDawn = null, contaMio = null;
  function scriviConta() {
    var el = document.getElementById('ProductCount');
    var eld = document.getElementById('ProductCountDesktop');
    if (!el) return;
    if (el.innerHTML !== contaMio) contaDawn = el.innerHTML;   // l'ha scritto Dawn
    var testo = contaDawn;
    if (scelta) {
      var m = contaDawn.replace(/<[^>]*>/g, '').match(/\d[\d,]*/);
      var tot = m ? m[0] : '0';
      var n = 0;
      schede.forEach(function (s) { if (s.handle && !s.li.classList.contains('bb-make-hidden')) n++; });
      // da telefono "5 of 48 products" non stava nella riga Filters | Sort |
      // conteggio e andava a capo: li' basta "5 products" (1 ott 2026)
      var corto = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      testo = corto
        ? n + (n === 1 ? ' product' : ' products')
        : n + ' of ' + tot + (tot === '1' ? ' product' : ' products');
    }
    contaMio = scelta ? testo : null;
    if (el.innerHTML !== testo) el.innerHTML = testo;
    if (eld && eld.innerHTML !== testo) eld.innerHTML = testo;
  }

  function disegna(marche) {
    lista.innerHTML = '';
    marche.forEach(function (m, i) {
      var li = document.createElement('li');
      var b  = document.createElement('button');
      b.type = 'button'; b.className = 'bb-rail__mk';
      b.setAttribute('aria-pressed', String(scelta === m.nome));
      b.innerHTML = '<span>' + m.nome + '</span><span class="bb-rail__mkn">' + m.n + '</span>';
      b.addEventListener('click', function () {
        scelta = (scelta === m.nome) ? null : m.nome;   // ricliccare toglie il filtro
        // Con un filtro acceso servono TUTTE le schede nel DOM, se no si filtra
        // solo la prima pagina e sembra che di quella marca ce ne siano tre.
        if (scelta && window.BBInfinite && window.BBInfinite.loadAll) {
          window.BBInfinite.loadAll().then(function () { leggiSchede(); applica(); });
        }
        Array.prototype.forEach.call(lista.querySelectorAll('.bb-rail__mk'), function (x) {
          x.setAttribute('aria-pressed', 'false');
        });
        b.setAttribute('aria-pressed', String(scelta === m.nome));
        applica();
      });
      if (i >= MOSTRA) li.hidden = true;
      li.appendChild(b);
      lista.appendChild(li);
    });
    if (tutte) {
      tutte.hidden = marche.length <= MOSTRA;
      tutte.onclick = function () {
        Array.prototype.forEach.call(lista.children, function (li) { li.hidden = false; });
        tutte.hidden = true;
      };
    }
  }

  /*
    Gli handle di TUTTA la collezione, non solo della pagina caricata.
    Prima `presenti` si costruiva dai <li> nel DOM: con 16 prodotti per pagina, su
    Intakes (50 prodotti) il filtro mostrava 3 marche invece di tutte, e i numeri
    accanto erano quelli della prima pagina. Si chiede l'elenco completo a Shopify
    e si tiene il DOM solo come ripiego. Corretto il 7 set 2026.
  */
  function tuttiGliHandle() {
    var h = rail.getAttribute('data-bb-rail-collection');
    var daDom = function () {
      var o = Object.create(null);
      schede.forEach(function (s) { if (s.handle) o[s.handle] = 1; });
      return o;
    };
    if (!h || !window.fetch) return Promise.resolve(daDom());
    return fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var o = Object.create(null), n = 0;
        (j.products || []).forEach(function (p) { if (p.handle) { o[p.handle] = 1; n++; } });
        return n ? o : daDom();
      })
      .catch(daDom);
  }

  function avvia() {
    leggiSchede();
    var mappa = perMarca();
    window.__bbPerMarca = mappa;

    // quali dei nostri prodotti hanno una compatibilita' dichiarata
    var conFit = Object.create(null);
    Object.keys(window.BBGarage.data.products).forEach(function (h) { conFit[h] = 1; });
    window.__bbHaFitment = conFit;

    tuttiGliHandle().then(function (presenti) { disegnaConta(mappa, presenti); });
  }

  function disegnaConta(mappa, presenti) {
    var marche = Object.keys(mappa).map(function (nome) {
      var n = 0;
      Object.keys(mappa[nome]).forEach(function (h) { if (presenti[h]) n++; });
      return { nome: nome, n: n };
    }).filter(function (m) { return m.n > 0; })
      .sort(function (a, b) { return b.n - a.n || a.nome.localeCompare(b.nome); });

    if (!marche.length) {
      var box = rail.querySelector('[data-bb-rail-makes]');
      if (box) box.hidden = true;
      // Ripiego del controllo sui tag fatto nel liquid (1 ott 2026): se non c'e'
      // nessuna marca da offrire spariscono anche il bottone Filters, che apriva
      // un pannello vuoto, e la colonna bianca su desktop.
      rail.hidden = true;
      if (apri) apri.hidden = true;
      var corpo = rail.closest('.bb-collbody');
      if (corpo) corpo.classList.add('bb-collbody--norail');
      return;
    }
    disegna(marche);

    // la riga "scegli la tua auto" solo quando l'auto non c'e'
    window.BBGarage.subscribe(function (p) { if (nocar) nocar.hidden = !!p; });

    // lo scorrimento infinito appende schede nuove: vanno filtrate anche loro
    document.addEventListener('bb:grid-grew', function () { leggiSchede(); applica(); });

    /*
      Dawn ridisegna tutta la griglia quando si cambia Sort o un filtro: le
      schede nuove arrivavano senza .bb-make-hidden, quindi si vedeva tutto con
      la marca ancora evidenziata (1 ott 2026). bb-infinite.js avvisa con
      bb:grid-replaced dopo essersi rimesso a posto: si rilegge la griglia, si
      riapplica la marca e, se ce n'e' una, si ricaricano tutte le pagine.
    */
    document.addEventListener('bb:grid-replaced', function () {
      leggiSchede(); applica();
      if (scelta && window.BBInfinite && window.BBInfinite.loadAll) {
        window.BBInfinite.loadAll().then(function () { leggiSchede(); applica(); });
      }
    });
  }

  /*
    Chi arriva dalla barra col bottone "See parts for my car" ha gia' detto
    cosa vuole: la pagina parte con il filtro acceso invece di mostrargli
    tutto il catalogo e lasciargli cercare l'interruttore.
    Si accende una volta sola, e solo se non e' gia' acceso.
  */
  (function scorciatoia() {
    if (new URLSearchParams(location.search).get('bb_only') !== '1') return;
    var prova = 0;
    var t = setInterval(function () {
      var tg = document.querySelector('[data-bb-fit-toggle]');
      if (tg && tg.offsetParent) {
        if (!tg.checked) tg.click();
        clearInterval(t);
      } else if (++prova > 20) { clearInterval(t); }   // 4 secondi e si smette
    }, 200);
  })();

  /*
    Dove si appiccica la colonna su desktop (1 ott 2026): subito sotto la
    striscia e l'header, che restano in cima mentre si scorre. L'header cambia
    altezza (il logo si rimpicciolisce scorrendo, a 1024px il menu va su due
    righe), quindi si misura dal vero ogni volta che cambia. Il CSS ne usa il
    valore in --bb-rail-top.
  */
  (function sottoHeader() {
    var hdr = document.querySelector('.section-header');
    var util = document.querySelector('.bb-util-section');
    function misura() {
      var fondo = 0;
      if (util && /sticky|fixed/.test(getComputedStyle(util).position)) fondo = util.getBoundingClientRect().bottom;
      if (hdr && /sticky|fixed/.test(getComputedStyle(hdr).position)) fondo = Math.max(fondo, hdr.getBoundingClientRect().bottom);
      rail.style.setProperty('--bb-rail-top', Math.max(0, Math.round(fondo)) + 'px');
    }
    misura();
    if (window.ResizeObserver && hdr) new ResizeObserver(misura).observe(hdr);
    window.addEventListener('resize', misura);
  })();

  /* ------------------------------------------------ il pannello da telefono */
  function apriPannello(si) {
    rail.classList.toggle('is-open', si);
    if (velo) velo.hidden = !si;
    if (apri) apri.setAttribute('aria-expanded', String(si));
    document.documentElement.style.overflow = si ? 'hidden' : '';
  }
  if (apri)   apri.addEventListener('click', function () { apriPannello(true); });
  if (chiudi) chiudi.addEventListener('click', function () { apriPannello(false); });
  if (velo)   velo.addEventListener('click', function () { apriPannello(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && rail.classList.contains('is-open')) apriPannello(false);
  });

  if (window.BBGarage && window.BBGarage.ready) {
    window.BBGarage.ready().then(avvia, function () {});
  } else {
    document.addEventListener('bb:garage:ready', function once() {
      document.removeEventListener('bb:garage:ready', once);
      if (window.BBGarage) window.BBGarage.ready().then(avvia, function () {});
    });
  }
})();
